import { Mutation } from 'react-apollo'
import createUser, {
  CreateUser,
  CreateUserInput
} from '../../graphql/mutations/createUser'
import withMutation from './withMutation'
import { GetProps } from '../../types'

class CreateUserMutation extends Mutation<CreateUser, CreateUserInput> {}

const CreateUserMutationCompleted = withMutation(createUser)(CreateUserMutation)

export type CreateUserMutationProps = GetProps<
  typeof CreateUserMutationCompleted
>
export type CreateUserMutationResult = CreateUser

export default CreateUserMutationCompleted



// WEBPACK FOOTER //
// ./src/components/mutations/CreateUserMutation.tsx